import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from 'component/utils/DatatableStyles'

const paginationOptions = {
    rowsPerPageText: "Show Per Page:", 
    rangeSeparatorText: "dari",
  };

const BankDatatables = ({ data, onEditBank, onDeleteBank }) => {
    const [search, setSearch] = useState("");

    const formattedData = data.map((item, index) => ({
      id: index + 1,
      ...item
    }));

    const filteredData = formattedData.filter((item) =>
      [item?.bank_id, item?.Nomor_rekening, item?.name_rekening]
        .some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))
    );
    
    const columns = [
      { name: "No", selector: (row) => row.id, width: "70px",style: { display: "flex", justifyContent: "center", alignItems: "center" }, sortable: true },
      { name: "Nama Bank", selector: (row) => row.name_bank, sortable: true, minWidth: "100px", maxWidth: "250px", grow:2 },
      { name: "Nomor Rekening", selector: (row) => row.nomor_rekening, sortable: true, minWidth: "100px", maxWidth: "400px", grow:2 },
      { name: "Nama Rekening", selector: (row) => row.name_rekening, sortable: true, minWidth: "100px", maxWidth: "250px", grow:2 },
      { 
        name: "Image",
        minWidth: "100px",
        maxWidth: "250px",
        grow:2,
        cell: (row) => (
          <img 
            src={`${process.env.REACT_APP_API}/images/${row.image_url}`} 
            alt="Bank Image" 
            style={{ width: "80px", height: "auto", objectFit: "contain" }}
          />
        )
      },      
      { 
        name: "Action", 
        minWidth: "100px", 
        maxWidth: "250px", grow:1,
        style: { display: "flex", justifyContent: "center", alignItems: "center" },
        cell: (row) => (
          <div>
              <button 
                class="btn btn-sm rounded-circle btn-warning me-2"
                onClick={() => onEditBank(row)}
              >
                <i class='bx bx-edit' style={{color:"white"}}></i>
              </button>

              <button 
                class="btn btn-sm rounded-circle btn-danger"
                onClick={() => onDeleteBank(row)}
              >
                <i class='bx bx-trash'></i>
              </button>
            </div>
        )
      }
    ];

  return (
    <div class="col-lg-12 mb-4">
        <div class="d-flex justify-content-start align-items-center mb-2">
                <input
                type="text"
                placeholder="Search..."
                class="form-control w-100"
                style={{ maxWidth: "200px" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                />
        </div>

        <div class="datatable-container">
            <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover={false}
            customStyles={DatatableStyles}
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 25]}
            paginationComponentOptions={paginationOptions}
            responsive
            />
        </div>
    </div>
  );
};

export default BankDatatables;
